// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__O7Z8E","col":"styles_col__3h2o4"};